var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "addendum-box" },
    [
      _vm._l(_vm.addendums, function (tab, index) {
        return _c(
          "div",
          { key: index, staticClass: "addendum-item" },
          [
            _c("label", { staticClass: "tab-label" }, [
              _vm._v(_vm._s(tab.title)),
            ]),
            _vm._v(" "),
            _vm._l(tab.fieldDiffs, function (field) {
              return _c(
                "div",
                { key: field.title, staticClass: "line-content" },
                [
                  field.diffMatchPatchResult
                    ? _c("div", { staticClass: "diff-match-patch-panel" }, [
                        _c("span", { staticClass: "emphasize-content" }, [
                          _vm._v(_vm._s(_vm.actionNameOf(field.action))),
                        ]),
                        _vm._v(" "),
                        _c("span", { staticClass: "inline-content" }, [
                          _vm._v(_vm._s(field.title)),
                        ]),
                        _vm._v(" "),
                        _c("pre", {
                          staticClass: "diff-row",
                          domProps: {
                            innerHTML: _vm._s(field.diffMatchPatchResult),
                          },
                        }),
                      ])
                    : [
                        field.oldValue
                          ? _c("div", { staticClass: "previous-panel" }, [
                              _c("span", { staticClass: "emphasize-content" }, [
                                _vm._v(_vm._s(_vm.actionDict.PREVIOUS)),
                              ]),
                              _vm._v(" "),
                              _c("span", { staticClass: "inline-content" }, [
                                _vm._v(_vm._s(field.title)),
                              ]),
                              _vm._v(" "),
                              _c("pre", {
                                staticClass: "diff-row field-value",
                                domProps: { innerHTML: _vm._s(field.oldValue) },
                              }),
                            ])
                          : _vm._e(),
                        _vm._v(" "),
                        _c("div", { staticClass: "update-panel" }, [
                          _c("span", { staticClass: "emphasize-content" }, [
                            _vm._v(_vm._s(_vm.actionNameOf(field.action))),
                          ]),
                          _vm._v(" "),
                          _c(
                            "span",
                            {
                              class: {
                                "removed-content": field.action === "D",
                                "inline-content": field.value,
                              },
                            },
                            [_vm._v(_vm._s(field.title))]
                          ),
                          _vm._v(" "),
                          _c("pre", {
                            staticClass: "field-value",
                            class: { "removed-content": field.action === "D" },
                            domProps: { innerHTML: _vm._s(field.value) },
                          }),
                        ]),
                      ],
                ],
                2
              )
            }),
          ],
          2
        )
      }),
      _vm._v(" "),
      !_vm.addendums || !(_vm.addendums.length > 0)
        ? _c("div", [
            _c("div", { staticClass: "previous-panel" }, [
              _c("span", [_vm._v(_vm._s(_vm.$t("hint.noContent")))]),
            ]),
          ])
        : _vm._e(),
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }